<template>
  <div class="modal-progress-preview-stdb-pdf-question">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container-outer">
          <ButtonClose
            class="modal-default-button"
            @click="$emit('close')"
          />
          <div
            ref="modalContainer"
            class="modal-container"
          >
            <div class="h-100 w-100 modal-contents-area">
              <div class="d-flex flex-column flex-fill modal-contents-area-inner">
                <div class="row">
                  <div
                    v-if="item.page == 'progress' && selectedHomeworkItemIndex !== 0"
                    class="col-2"
                  >
                    <div class="show-three-point">
                      No.{{ selectedHomeworkItemIndex }}
                    </div>
                  </div>
                  <div class="col-10">
                    <div class="show-three-point">
                      {{ item.taskName }}
                    </div>
                  </div>
                </div>
                <div class="preview-wrapper pt-2">
                  <div
                    class="col preview"
                  >
                    <div class="card w-100 h-100 d-flex flex-column">
                      <div class="card-header d-flex justify-content-between align-items-center">
                        {{ $t("labels.preview") }}
                        <div
                          v-if="filePaths.length"
                          class="preview-image-layout-count"
                        >
                          {{ currentIndex + 1 + " / " + filePaths.length }}
                        </div>
                      </div>
                      <div class="window-body d-flex flex-column flex-fill">
                        <div class="preview-window">
                          <div class="card overflow-auto h-100">
                            <SettingPreviewImage
                              v-if="currentPath"
                              :image="currentPath"
                              class="card-body"
                            />
                          </div>
                        </div>
                        <ul class="prev-area">
                          <li
                            v-show="hasPrevPage"
                            class="prev"
                            @click="currentIndex--"
                          />
                        </ul>
                        <ul class="next-area">
                          <li
                            v-show="hasNextPage"
                            class="next"
                            @click="currentIndex++"
                          />
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <LoadingScreen v-if="isLoading" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalConfirmOkOnly
      v-if="showConfirmCaution"
      :message="cautionMessage"
      @close-confirm-modal-ok-only="closeModal"
    />
  </div>
</template>

<script>
/**
 * 宿題管理 -STDBレイアウト通り・PDFのプレビューモーダル
 */
import mixin from "@/mixins/mixin"
import ButtonClose from "@/components/atoms/buttons/ButtonClose.vue"
import SettingPreviewImage from "@/components/atoms/SettingPreviewImage.vue"
import LoadingScreen from "@/components/atoms/LoadingScreen.vue"
import homeworkRepository from "@/repositories/homework"
import ModalConfirmOkOnly from "@/components/organisms/modal/ModalConfirmOkOnly.vue"

export default {
  name: "ModalProgressPreviewStdbPdfQuestion",
  components: {
    ButtonClose,
    SettingPreviewImage,
    LoadingScreen,
    ModalConfirmOkOnly,
  },
  mixins: [mixin],
  props: {
    item: {
      type: Object,
      require: true,
      default: function () {
        return {}
      },
    },
    selectedHomeworkItemIndex: {
      type: Number,
      default: function () {
        return 0
      },
    },
  },
  emits: [
    "close",
  ],
  data: function () {
    return {
      isLoading: false,
      filePaths: [],
      currentIndex: 0,
      showConfirmCaution: false,
      cautionMessage: "",
    }
  },
  computed: {
    /**
     * 現在のパス
     */
    currentPath: function () {
      if (this.filePaths.length === 0) {
        return ""
      }
      return this.filePaths[this.currentIndex]
    },
    /**
     * 前のページがあるか？
     */
    hasPrevPage: function () {
      return this.currentIndex > 0
    },
    /**
     * 次のページがあるか？
     */
    hasNextPage: function () {
      return this.currentIndex < this.filePaths.length - 1
    },
  },
  async mounted() {
    // リサイズ時にモーダルサイズの調整を行う（iPad対応）
    window.addEventListener('resize', () => {
      this.adjustModal();
    });
    this.adjustModal();

    let filesInfo
    if (this.item.fileList.length === 0) {
      this.isLoading = true
      try {
        filesInfo = await this.fetchFilesList()
      } catch {
        // メッセージ出力
        if (this.item.isPublished) {
          this.showModalOkOnly(
            this.$t("messages.error.uploadPublicEndPreviewForPublish")
          )
        } else {
          this.showModalOkOnly(this.$t("messages.error.uploadPublicEndPreview"))
        }
        this.isLoading = false
        return
      }
    } else {
      filesInfo = this.item.fileList.map((file) => {
        return {
          fileName: file.file_name,
          filePath: file.file_image,
        }
      })
    }

    this.filePaths = filesInfo.map((x) => x.filePath)
    this.isLoading = false
  },
  methods: {
    /**
     * モーダルサイズ調整
     */
    adjustModal() {
      var e = this.$refs.modalContainer;
      if (e) {
        var v = window.innerHeight;
        e.style.height = `${ (v - 20) }px`;
      }
    },

    /**
     * ファイルリストを取得
     */
    fetchFilesList: async function () {
      const result = await homeworkRepository.getHomeworkStreamFileListForPreview(
        this.loginUserInfo.accountId,
        this.loginUserInfo.schoolId,
        this.item.mode,
        this.item.key,
        this.item.keyNo,
        this.loginUserInfo.lmsApiToken
      )
      return result;
    },
    /*
     * 閉じるモーダル
     */
    closeModal: function () {
      this.showConfirmCaution = false
      this.$emit("close")
    },

    /**
     * OKだけのモーダルを表示する
     */
    showModalOkOnly: function (message) {
      this.cautionMessage = message
      this.showConfirmCaution = true
    },
  },
}
</script>

<style lang="scss" scoped>
.show-three-point {
  max-width: fit-content;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.page-transition-button {
  margin: auto 0;
  cursor: pointer;

  i {
    font-size: 48px;
    color: #0070c0;
  }
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;

    .modal-container-outer {
      width: 100%;
      margin-left: auto;
      margin-right: auto;

      .modal-default-button {
        position: absolute;
        left: calc(100vw - 50px);
      }

      .modal-container {
        position: relative;
        width: calc(100vw - 100px);
        height: calc(100vh - 20px);
        margin: auto;
        padding: 15px;
        background-color: #fff;
        border-radius: 10px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;

        .modal-contents-area {
          display: flex;
          flex-direction: column;

          .modal-contents-area-inner {
            height: 100%;
          }
        }
      }

      .preview-image-layout-count {
        color: var(--bs-body-color);
        font-weight: normal;
      }

      .prev-area {
        position: absolute;
        top: 50%;
        left: 12px;
        margin: 0;
        padding: 0;
      }

      .prev {
        display: block;
        padding: 20px 15px;
        cursor: pointer;
        height: auto;
        transform: translateY(-50%);

        &::before {
          content: "";
          display: inline-block;
          position: absolute;
          background: #0070c0;
          width: 20px;
          height: 4px;
          transform: rotate(-45deg);
          top: 12px;
          left: 5px;
        }

        &::after {
          content: "";
          display: inline-block;
          position: absolute;
          background: #0070c0;
          width: 20px;
          height: 4px;
          transform: rotate(45deg);
          top: 24px;
          left: 5px;
        }
      }

      .next-area {
        position: absolute;
        top: 50%;
        right: 12px;
        margin: 0;
        padding: 0;
      }

      .next {
        display: block;
        padding: 20px 15px;
        cursor: pointer;
        height: auto;
        transform: translateY(-50%);

        &::before {
          content: "";
          display: inline-block;
          position: absolute;
          background: #0070c0;
          width: 20px;
          height: 4px;
          transform: rotate(-45deg);
          top: 24px;
          right: 5px;
        }

        &::after {
          content: "";
          display: inline-block;
          position: absolute;
          background: #0070c0;
          width: 20px;
          height: 4px;
          transform: rotate(45deg);
          top: 12px;
          right: 5px;
        }
      }
    }
  }
}

.preview-wrapper {
  min-height: 0;
  flex: 1;
}

.preview {
  height: 100%;

  .card-header {
    border-bottom: none;
    background: var(--bs-table-header);
    color: var(--bs-layout-theme);
    font-weight: bold;
  }
}

.window-body {
  padding: 1rem 54px;
  position: relative;
  min-height: 0;
}

.preview-window {
  min-height: 0;
  flex: 1;
}
</style>
